var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 18.8874,
    y2: -0.5,
    transform: "matrix(0.736857 0.676049 -0.736857 0.676049 2.71362 4.03607)",
    stroke: "#273561",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: "2px"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 18.6925,
    y2: -0.5,
    transform: "matrix(-0.736857 0.676049 -0.736857 -0.676049 16.9993 2.85715)",
    stroke: "#273561",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.bf7bb1765b89e7deadfcae7a9fdccfac.svg";
export { ForwardRef as ReactComponent };